import React from 'react';

const Bard_Summarize = () => {
  return (
    <div>
      <h1>Bard_Summarize</h1>
      <p>This is the Bard_Summarize component.</p>
    </div>
  );
};

export default Bard_Summarize;
